import React from 'react';
import { useCart } from '../context/CartContext';
import './TimePage.css';

const TimePage = () => {
    const { recentOrders } = useCart();
    const lastOrder = recentOrders.length > 0 ? recentOrders[0] : null;

    if (!lastOrder) {
        return (
            <div className="time-page empty">
                <div className="empty-content">
                    <span style={{ fontSize: '48px' }}>⏰</span>
                    <h2>No hay pedidos recientes</h2>
                    <p>Realiza un pedido para ver el tiempo de espera aquí.</p>
                </div>
            </div>
        );
    }

    // QR Code generator URL (mimicking the one in Checkout)
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=ORDER-${lastOrder.id}`;

    return (
        <div className="time-page">
            <div className="time-header">
                <h1>Tiempo de Espera</h1>
                <p>Estado de tu último pedido</p>
            </div>

            <div className="order-status-card">
                <div className="order-number-large">
                    Pedido #{lastOrder.id}
                </div>

                <div className="status-indicator">
                    <div className="pulsing-dot"></div>
                    <span>Preparando su pedido</span>
                </div>

                <div className="time-display">
                    <div className="time-circle">
                        <span className="minutes">10-15</span>
                        <span className="label">minutos</span>
                    </div>
                    <p className="pickup-text">Tiempo estimado para retirar</p>
                </div>

                <div className="qr-section">
                    <img src={qrCodeUrl} alt={`QR Code for order ${lastOrder.id}`} className="qr-image" />
                    <p>Muestra este código al retirar</p>
                </div>

                <div className="order-summary-mini">
                    <h3>Detalle del pedido:</h3>
                    <ul>
                        {lastOrder.items && lastOrder.items.map((item, index) => (
                            <li key={index}>
                                {item.quantity}x {item.name} ({item.size})
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="pickup-location">
                    <h3>Retirar en:</h3>
                    <p>{lastOrder.store ? lastOrder.store.name : 'Tienda Seleccionada'}</p>
                    <p className="address">{lastOrder.store ? lastOrder.store.address : ''}</p>
                </div>
            </div>
        </div>
    );
};

export default TimePage;
